import { render, staticRenderFns } from "./NonBondedFlagChip.vue?vue&type=template&id=08a7b599"
import script from "./NonBondedFlagChip.vue?vue&type=script&lang=js"
export * from "./NonBondedFlagChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports